import { Menu } from './menu';

export class Routes {
  industriesMenu: Menu[] = [
    {
      name: 'Aviation and Transports',
      link: '/industries/aviation-transport', // Parent link, though dropdowns usually just toggle
      children: [
        { name: 'Aviation', link: '/industries/aviation' },
        { name: 'Rail', link: '/industries/rail' },
        { name: 'Road', link: '/industries/road' },
      ],
    },
    { name: 'Insurance', link: '/industries/insurance' },
    { name: 'Mining', link: '/industries/mining' },
    {
      name: 'Schools and Universities',
      link: '/industries/schools-and-universities',
    },
    { name: 'Sporting Facilities', link: '/industries/sporting' },
  ];

  productsMenu: Menu[] = [
    // { name: 'AeroSense Ai', link: '/products/aeroSense_Ai' },
    {
      name: 'Air Quality',
      link: '/products/air_quality',
      children: [
        {
          name: 'Indoor Monitoring',
          link: '/products/air_quality/indoor-monitoring',
        },
        {
          name: 'Outdoor Monitoring',
          link: '/products/air_quality/outdoor-monitoring',
        },
      ],
    },
    { name: 'API Solution', link: '/products/api-solution' },
    { name: 'Hardware Options', link: '/products/hardware-options' },
    { name: 'Mobile Application', link: '/products/application' },
    { name: 'WeatherGuard', link: '/products/weatherguard' },
    { name: 'Web-Based Portal', link: '/products/web-based-portal' },
  ];

  servicesMenu: Menu[] = [
    { name: 'Additional Services', link: '/services/additional-services' },
    {
      name: 'Implementation and Support',
      link: '/services/implementation-and-support',
    },
  ];
}
